import React from 'react';

import moment from 'moment';

import TextButton from 'CommonComponents/TextButton';
import Tooltip from 'CommonComponents/Tooltip';

import DownloadIcon from 'Assets/icons/download.svg';
import EditIcon from 'Assets/icons/edit.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function ExpenseLibraryTemplatesIndexTableRow(props) {
    function showTemplate() {
        window.location.href = props.templatesShowUrl.replace('EXPENSE_LIBRARY_TEMPLATE_ID', props.template.id);
    }

    return (
        <tr>
            <td className="tw-cursor-pointer" onClick={() => showTemplate()}>
                {props.template.name}
            </td>
            <td className="tw-cursor-pointer" onClick={() => showTemplate()}>
                {props.template.category}
            </td>
            <td className="tw-cursor-pointer" onClick={() => showTemplate()}>
                {props.template.description}
            </td>
            <td className="tw-cursor-pointer" onClick={() => showTemplate()}>
                {moment(props.template.created_at).format('YY-MM-DD')}
            </td>
            <td
                className="tw-cursor-pointer"
                onClick={() => showTemplate()}
            >{`${props.template.created_by_user.first_name} ${props.template.created_by_user.last_name}`}</td>
            <td>
                {props.template.expenses_count > 0 && (
                    <form action={props.templatesExportUrl.replace('EXPENSE_LIBRARY_TEMPLATE_ID', props.template.id)} method="post">
                        <input type="hidden" name="_token" value={window.csrfToken} />
                        <Tooltip placement="left" tooltipContent="Download" tooltipType="text">
                            <div className="tw-cursor-pointer">
                                <TextButton title="Download">
                                    <DownloadIcon className="tw-w-3 tw-h-3" />
                                    {$t('Download')}
                                </TextButton>
                            </div>
                        </Tooltip>
                    </form>
                )}
            </td>
            <td>
                <div className="tw-flex tw-items-center tw-gap-x-3">
                    <TextButton onClick={() => props.clickRow(props.template)}>
                        <EditIcon className="tw-w-3 tw-h-3" />
                        {$t('Edit')}
                    </TextButton>
                    <TextButton variant="danger" onClick={() => props.deleteRow(props.template)}>
                        <TrashIcon className="tw-w-3 tw-h-3" />
                        {$t('Delete')}
                    </TextButton>
                </div>
            </td>
        </tr>
    );
}
